<app-journey-pdf-preview previewMode="expanded"></app-journey-pdf-preview>
